module.exports = {
	"name": "hiui-pc",
	"version": "1.3.7",
	"description": "UI components for wantu.cn",
	"homepage": "https://hi-fe.github.io/hiui-pc/",
	"main": "./dist/hiuipc.js",
	"scripts": {
		"dev": "node build/dev-server.js",
		"build": "node build/build.js",
		"package": "node build/package.js",
		"lint": "eslint --ext .js,.vue src"
	},
	"dependencies": {
		"github-markdown-css": "^2.6.0",
		"highlight.js": "^9.10.0",
		"markdown-it": "^8.3.1",
		"purecss": "^0.6.0",
		"swiper": "^3.4.2",
		"vue": "^2.2.2",
		"vue-clipboards": "^0.2.6",
		"vue-router": "^2.2.0"
	},
	"devDependencies": {
		"autoprefixer": "^6.7.2",
		"babel-core": "^6.22.1",
		"babel-eslint": "^7.1.1",
		"babel-loader": "^6.2.10",
		"babel-plugin-transform-runtime": "^6.22.0",
		"babel-preset-env": "^1.2.1",
		"babel-preset-stage-2": "^6.22.0",
		"babel-register": "^6.22.0",
		"chalk": "^1.1.3",
		"connect-history-api-fallback": "^1.3.0",
		"copy-webpack-plugin": "^4.0.1",
		"css-loader": "^0.26.1",
		"eslint": "^3.14.1",
		"eslint-config-standard": "^6.2.1",
		"eslint-friendly-formatter": "^2.0.7",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^2.0.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-standard": "^2.0.1",
		"eventsource-polyfill": "^0.9.6",
		"express": "^4.14.1",
		"extract-text-webpack-plugin": "^2.0.0",
		"file-loader": "^0.10.0",
		"friendly-errors-webpack-plugin": "^1.1.3",
		"function-bind": "^1.1.0",
		"html-webpack-plugin": "^2.28.0",
		"http-proxy-middleware": "^0.17.3",
		"minimist": "^1.2.0",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^1.3.0",
		"ora": "^1.1.0",
		"rimraf": "^2.6.0",
		"semver": "^5.3.0",
		"style-loader": "^0.17.0",
		"stylus": "^0.54.5",
		"stylus-loader": "^3.0.1",
		"url-loader": "^0.5.7",
		"vue-loader": "^11.1.4",
		"vue-markdown-loader": "^0.6.2",
		"vue-style-loader": "^2.0.0",
		"vue-template-compiler": "^2.2.4",
		"webpack": "^2.2.1",
		"webpack-bundle-analyzer": "^2.2.1",
		"webpack-dev-middleware": "^1.10.0",
		"webpack-hot-middleware": "^2.16.1",
		"webpack-merge": "^2.6.1"
	},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"browserslist": [
		"> 1%",
		"last 2 versions",
		"not ie <= 8"
	]
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 729
// module chunks = 0